import React from 'react'
import {toggle} from 'opticks'

import {Text} from '@daedalus/atlas/Text'
import {FormattedMessageWrapper} from '@daedalus/core/src/localization/components/FormattedMessage'
import {roomLabels} from '@daedalus/core/src/offer/business/getRoomLabels'

export const YourChoiceLabel = () => {
  return (
    <Text
      data-id="YourChoiceLabel"
      variant="bodyXS"
      colorPath="content.featured.c500"
    >
      {toggle(
        'd8f5ddb4-your-selection-label-ap-and-srp',
        <FormattedMessageWrapper
          id={roomLabels.yourChoice.id}
          defaultMessage={roomLabels.yourChoice.defaultMessage}
        />,
        <FormattedMessageWrapper
          id={roomLabels.yourSelection.id}
          defaultMessage={roomLabels.yourSelection.defaultMessage}
        />
      )}
    </Text>
  )
}
